import React from "react";
import { Modal, Button } from "react-bootstrap";

const SessionExpiredModal = ({ show, onLogin }) => (
  <Modal show={show} centered backdrop="static" keyboard={false}>
    <Modal.Header style={{ backgroundColor: "#f8d7da", borderBottom: "1px solid #f5c6cb" }}>
      <Modal.Title style={{ color: "#721c24" }}>
        ⚠️ Session Expired
      </Modal.Title>
    </Modal.Header>
    <Modal.Body style={{ textAlign: "center", padding: "2rem" }}>
      <p style={{ fontSize: "1rem", color: "#333", marginBottom: "0.5rem" }}>
        Your session has expired due to inactivity.
      </p>
      <p style={{ fontSize: "0.9rem", color: "#666" }}>
        Please log in again to continue.
      </p>
    </Modal.Body>
    <Modal.Footer style={{ justifyContent: "center" }}>
      <Button variant="primary" onClick={onLogin}>
        Go to Login
      </Button>
    </Modal.Footer>
  </Modal>
);

export default SessionExpiredModal;
